var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconIn = function SvgIconIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9811",
    d: "M12-.001A12 12 0 0 0 1.19 6.782H22.81a12 12 0 0 0-10.81-6.783"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M12 24a12 12 0 0 0 10.809-6.783H1.19A12 12 0 0 0 12 23.999"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M12 16.173a4.174 4.174 0 1 0 0-8.348 4.174 4.174 0 0 0 0 8.348"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 14.608a2.609 2.609 0 1 0 0-5.218 2.609 2.609 0 0 0 0 5.218"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "m12 8.78.806 1.826 1.983-.216L13.61 12l1.179 1.61-1.983-.216L12 15.219l-.805-1.825-1.983.215L10.39 12 9.213 10.39l1.983.216z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconIn;